import React from 'react';
import { TALL_CAROUSEL_ASPECT_RATIO } from '../constants';
import CarouselCard from './CarouselCard';
import { commonDefaultProps, commonPropTypes } from './constants';

const TallCarouselCard = props => (
  <CarouselCard
    aspectRatio= {TALL_CAROUSEL_ASPECT_RATIO}
    {...props}
  />
);

TallCarouselCard.propTypes = commonPropTypes;
TallCarouselCard.defaultProps = commonDefaultProps;

export default TallCarouselCard;
